package com.sushanthande.portfolio.models

data class SkillModel(val drawable : String, val title:String)